import { render } from "./BottomPopUpItem.vue?vue&type=template&id=ab37edc6&scoped=true&ts=true"
import script from "./BottomPopUpItem.vue?vue&type=script&lang=ts"
export * from "./BottomPopUpItem.vue?vue&type=script&lang=ts"

import "./BottomPopUpItem.vue?vue&type=style&index=0&id=ab37edc6&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab37edc6"]])

export default __exports__